export function usePageTitleState() {
  return useState('pageTitle', () => '');
}
